import * as Common from './common'

$(document).ready(function () {
  if (document.body.dataset.action == 'instagram_login') {
    const ig_account_id = Common.getParam('ig_account_id');
    const ref = Common.getParam('ref')
    const return_url = Common.getParam('return_url');
    const insta_dm_link = "https://ig.me/m/" + ig_account_id + "?ref=" + ref;

    // 「インスタログインの準備中」のバーのアニメーションの時間
    var animationDuration = 1000;

    const progressBar = $('.instagram-dialog-text-progress-gauge-bar');
    let startTime = null;

    function animate(timestamp) {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / animationDuration, 1);
      progressBar.css('width', (progress * 100) + '%');

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        redirectToInstaDmLink();
      }
    }
    requestAnimationFrame(animate);

    // 「開く」ボタンでInstagramアプリを開く
    // アラートは残しておく（アプリに飛べなかったユーザーが戻ってきた時にフォールバックを使えるように）
    $('#ig-native-open-btn').on('click', function () {
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = /android/i.test(ua);

      if (isAndroid) {
        const igPath = 'ig.me/m/' + ig_account_id + '?ref=' + ref;
        const fallbackUrl = encodeURIComponent(insta_dm_link);
        window.location.href = 'intent://' + igPath + '#Intent;scheme=https;package=com.instagram.android;S.browser_fallback_url=' + fallbackUrl + ';end';
      } else {
        window.open(insta_dm_link, '_blank');
      }
    });

    const move_to = Common.getParam('move_to') || 'menu';
    const liff_link = Common.getParam('liff_link');
    const liff_fullview_link = Common.getParam('liff_fullview_link');

    // LIFFボタンのhrefを設定（stylistページのstylists.jsと同じロジック）
    if (liff_link) {
      $("a.ig-profile-line-liff-button").attr('href', liff_link + '&move_to=profile');
      $("a.ig-menu-line-liff-button").attr('href', liff_link + '&move_to=menu');
    }
    if (liff_fullview_link) {
      $("a.ig-counseling-line-liff-button").attr('href', liff_fullview_link + '&move_to=counseling');
    }
    if (liff_link) {
      $("a.ig-coupon-line-liff-button").attr('href', liff_link + '&move_to=date');
    }

    // 「Instagramアプリが開かない場合」→ LINEログインダイアログを表示
    // ig-native-alert-overlayは非表示にせず下に残す（暗い背景として機能させ、オーバーレイの重なりを防ぐ）
    $('#ig-fallback-line-login').on('click', function () {
      // アラートのボックスだけ非表示にし、オーバーレイ背景は残す
      $('.ig-native-alert').hide();
      $('#ig_line_login_dialog').fadeIn(300);
    });

    // LINEログインダイアログ「閉じる」→ Instagramアラートに戻る
    $('#ig-page-line-login-close').on('click', function () {
      $('#ig_line_login_dialog').fadeOut();
      $('.ig-native-alert').fadeIn(200);
    });

    // オーバーレイ背景クリック → LINEダイアログが表示中なら閉じてInstagramアラートに戻る
    $('#ig-native-alert-overlay').on('click', function (e) {
      if ($(e.target).closest('#ig_line_login_dialog, #ig_line_rizm_auth_dialog, .ig-native-alert').length) return;
      if ($('#ig_line_rizm_auth_dialog').is(':visible')) {
        $('#ig_line_rizm_auth_dialog').fadeOut();
        $('.ig-native-alert').fadeIn(200);
      } else if ($('#ig_line_login_dialog').is(':visible')) {
        $('#ig_line_login_dialog').fadeOut();
        $('.ig-native-alert').fadeIn(200);
      }
    });

    // LINEログインボタン → line_rizm_auth_dialog（認証ダイアログ）を表示
    // stylistページと同じ流れ: line_login_dialog → line_rizm_auth_dialog → LIFF遷移
    $('#ig-page-line-login-btn').on('click', function () {
      // move_toに応じて該当のLIFFボタンだけ表示（stylists.jsのline-login-dialog-buttonと同じロジック）
      $('.ig-line-liff-button').hide();
      if (move_to === 'profile') {
        $(".ig-profile-line-liff-button").show();
      } else if (move_to === 'menu') {
        $(".ig-menu-line-liff-button").show();
      } else if (move_to === 'counseling') {
        $(".ig-counseling-line-liff-button").show();
      } else if (move_to === 'coupon') {
        $(".ig-coupon-line-liff-button").show();
      }

      // line_login_dialogを閉じてline_rizm_auth_dialogを表示
      $('#ig_line_login_dialog').hide();
      $('#ig_line_rizm_auth_dialog').fadeIn(300);
    });

    // LIFFボタンクリック → LIFFを開いてからstylistページに戻る
    $('.ig-line-liff-button').on('click', function (e) {
      e.preventDefault();
      const liffUrl = $(this).attr('href');
      if (liffUrl) {
        window.open(liffUrl, '_blank');
      }
      if (return_url) {
        window.location.href = return_url;
      }
    });

    function redirectToInstaDmLink() {
      // プログレスバーのページはそのまま残し、アラートをふわっと表示
      $('#ig-native-alert-overlay').css('display', 'flex').hide().fadeIn(300);
    }
  }
});
